import {Button, ButtonProps, IconButton, Popover, Stack, styled, useMediaQuery} from "@mui/material";
import {useState} from "react";
import SelectApplicantComponent from "./SelectApplicantComponent";
import SelectLanguageComponent from "./SelectLanguageComponent";
import {useTranslation} from "i18nano";
import {useNavigate} from "react-router-dom";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {useUserStore} from "../stores/userStore";
import {axiosInstance} from "../instances/axiosInstance";
import {useApplicantCheck} from "../hooks/useApplicantCheck";
import {blue} from "@mui/material/colors";
import SettingsIcon from '@mui/icons-material/Settings';

const ColorButton = styled(Button)<ButtonProps>(({theme}) => ({
    color: theme.palette.getContrastText(blue[700]),
    backgroundColor: "transparent",
    borderWidth: 1,
    borderColor: `rgba(0, 0, 0, 0.23)`,
    borderStyle: "solid",
    textTransform: "none",
    fontWeight: "normal",
    fontStyle: "normal",
    fontSize: "1rem",
    '&:hover': {
        borderColor: `rgba(0, 0, 0, 0.87)`
    },
    [theme.breakpoints.down('sm')]: {
        color: 'black',
    }
}));

const AppBarMenu = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event: any) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const open = Boolean(anchorEl);
    const navigate = useNavigate();
    const t = useTranslation();
    const userStore = useUserStore();
    const {applicant} = useApplicantCheck();

    //@ts-ignore
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'));

    const appBarButtons =
            <>
                {
                        applicant?.isAgent &&
                        <ColorButton onClick={() => navigate(`/agent/${applicant.id}/clients`)}
                                     size={"large"}
                                     startIcon={<SettingsIcon/>}
                        >
                            Clients
                        </ColorButton>
                }
                <SelectApplicantComponent/>
                <SelectLanguageComponent style={{
                    color: matches ? "white" : "black",
                    borderColor: "white",
                    maxWidth: 250,
                    minWidth: 140,
                    margin: matches ? "0 10px" : "10px 0"
                }}/>
                <Button onClick={async () => {
                    const token = localStorage.getItem("token");
                    axiosInstance.post(`token/revoke`, null, {
                        headers: {
                            "Authorization": `Bearer ${token}`
                        }
                    });
                    setAnchorEl(null);
                    userStore.logout();
                    navigate("/login")
                }} color="inherit">
                    {t("Log out")}
                </Button>
            </>
    if (userStore.status === "NOT_AUTHENTICATED") return <SelectLanguageComponent
            style={{color: "white", borderColor: "white", maxWidth: 250, minWidth: 140}}/>;

    if (matches) return (
            <Stack spacing={1} direction={"row"}>
                {appBarButtons}
            </Stack>
    )

    return (
            <>
                <IconButton aria-describedby={"popover_menu"} onClick={handleClick} size="large">
                    <MoreVertIcon style={{fill: "white"}}/>
                </IconButton>
                <Popover
                        id={"popover_menu"}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                >
                    <Stack spacing={2} width={200} padding={2} direction={"column"} alignItems={"stretch"}>
                        {appBarButtons}
                    </Stack>
                </Popover>
            </>
    )

}

export default AppBarMenu;